export default "__VITE_ASSET__CcIcQhMP__"